module.exports = __webpack_public_path__ + "img/sevilla_background_hero.79252d76.png";